export var PAST_PERFORMANCE = "PAST_PERFORMANCE";
export var PAST_PERFORMANCE_ADD_MSG = "PAST_PERFORMANCE_ADD_MSG";
export var PAST_PERFORMANCE_CLEAR_MSG = "PAST_PERFORMANCE_CLEAR_MSG";
export var PAST_PERFORMANCE_ERROR = "PAST_PERFORMANCE_ERROR";
export var PAST_PERFORMANCE_HIDE_ERROR = "PAST_PERFORMANCE_HIDE_ERROR";
export var PAST_PERFORMANCE_START_LOADER = "PAST_PERFORMANCE_START_LOADER";
export var PAST_PERFORMANCE_STOP_LOADER = "PAST_PERFORMANCE_STOP_LOADER";
